/**
 * 订单小票 / 详情里 addon 行展示：与 C 端下单 buildSubItemPayloadRow 一致，
 * 按 sortIndex、splitSlotIndex 排序，并拼出分类行（含分部位 splitSlotTitle）。
 */

function pickField(obj, camel, snake) {
  if (!obj || typeof obj !== 'object') return undefined
  if (obj[camel] !== undefined && obj[camel] !== null && obj[camel] !== '') return obj[camel]
  if (snake && obj[snake] !== undefined && obj[snake] !== null && obj[snake] !== '') return obj[snake]
  return undefined
}

export function receiptAddonCategoryLabel(sub) {
  if (!sub || typeof sub !== 'object') return 'Add-on'
  const base = String(pickField(sub, 'addonCategory', 'addon_category') || '').trim()
  const slot = String(pickField(sub, 'splitSlotTitle', 'split_slot_title') || '').trim()

  let core
  if (slot && base && !base.includes(slot)) core = `${base} · ${slot}`
  else if (slot && !base) core = slot
  else if (base) core = base
  else if (slot) core = slot
  else core = ''

  if (!core) return 'Add-on'
  return core
}

function receiptSortKey(sub, origIdx) {
  const sortIndex = Number(pickField(sub, 'sortIndex', 'sort_index'))
  const si = Number.isFinite(sortIndex) ? sortIndex : 0
  const slotIdx = Number(pickField(sub, 'splitSlotIndex', 'split_slot_index'))
  const sp = Number.isFinite(slotIdx) ? slotIdx : -1
  return { si, sp, origIdx }
}

/**
 * @param {Array} itemAddons 订单行 item.itemAddons
 * @returns {Array} 带 _receiptCategoryLabel、_receiptShowCategory、_receiptIsLast 的浅拷贝行（用于展示）
 */
export function prepareItemAddonsForReceipt(itemAddons) {
  const list = Array.isArray(itemAddons) ? itemAddons : []
  if (!list.length) return []

  const decorated = list.map((row, origIdx) => ({ row, origIdx }))
  decorated.sort((a, b) => {
    const ka = receiptSortKey(a.row, a.origIdx)
    const kb = receiptSortKey(b.row, b.origIdx)
    if (ka.si !== kb.si) return ka.si - kb.si
    if (ka.sp !== kb.sp) return ka.sp - kb.sp
    return a.origIdx - b.origIdx
  })

  const sorted = decorated.map(d => d.row)
  const n = sorted.length
  return sorted.map((sub, i) => {
    const categoryLabel = receiptAddonCategoryLabel(sub)
    const prevLabel = i > 0 ? receiptAddonCategoryLabel(sorted[i - 1]) : null
    return {
      ...sub,
      _receiptCategoryLabel: categoryLabel,
      _receiptShowCategory: categoryLabel !== prevLabel,
      _receiptIsLast: i === n - 1
    }
  })
}

function subItemRowNeedsExplicitCategoryLabel(r) {
  if (!r || typeof r !== 'object') return false
  const branch = String(pickField(r, 'splitBranchType', 'split_branch_type') || '').toLowerCase()
  if (branch === 'whole' || branch === 'portion') return true
  const slot = String(pickField(r, 'splitSlotTitle', 'split_slot_title') || '').trim()
  if (slot) return true
  const si = Number(pickField(r, 'splitSlotIndex', 'split_slot_index'))
  if (Number.isFinite(si) && si >= 0) return true
  if (Number(pickField(r, 'allowSplit', 'allow_split')) === 1) return true
  return false
}

/**
 * 购物车 / 结账单行文案：与 Flutter `formatCartSubItemsSummary` 一致
 * @param {Array} subItems 购物车行的 food.subItems
 * @returns {string}
 */
export function formatCartSubItemsSummary(subItems) {
  const rows = prepareItemAddonsForReceipt(subItems)
  if (!rows.length) return ''

  const grouped = new Map()
  for (const s of rows) {
    const label = String(s._receiptCategoryLabel || 'Add-ons')
    const qtyRaw = pickField(s, 'addonQty', 'addon_qty')
    const qty = Number(qtyRaw) > 0 ? Number(qtyRaw) : 1
    const name = String(pickField(s, 'subItemName', 'sub_item_name') || '').trim()
    if (!name) continue
    if (!grouped.has(label)) grouped.set(label, [])
    grouped.get(label).push(`${qty}×${name}`)
  }

  const forceShowKeys = grouped.size > 1 || rows.some(subItemRowNeedsExplicitCategoryLabel)

  const parts = []
  grouped.forEach((vals, key) => {
    if (!forceShowKeys && grouped.size === 1) {
      parts.push(vals.join(', '))
    } else {
      parts.push(`${key}: ${vals.join(', ')}`)
    }
  })
  return parts.join(', ')
}
